import React, { useEffect } from "react";
import { X, FileText } from "lucide-react";

const PAPER = "https://images.pexels.com/photos/235985/pexels-photo-235985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const JournalPanel = ({ open, onClose, entries }) => {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="journal-modal">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative w-full max-w-2xl mx-4 p-12 animate-fadein"
        style={{
          backgroundImage: `linear-gradient(rgba(220,210,190,0.94), rgba(220,210,190,0.94)), url(${PAPER})`,
          backgroundSize: "cover",
          transform: "rotate(-0.8deg)",
          boxShadow: "0 30px 80px rgba(0,0,0,0.7)",
        }}
      >
        <div className="flex items-center justify-between mb-6" style={{ color: "#2a1e10" }}>
          <div className="flex items-center gap-2">
            <FileText size={16} />
            <h3 className="font-serif italic text-xl">Jack&apos;s Notes</h3>
          </div>
          <button onClick={onClose} className="hover:text-emergency transition-colors" data-testid="journal-close">
            <X size={18} />
          </button>
        </div>
        <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2" style={{ color: "#1a1108" }}>
          {entries.length === 0 ? (
            <p className="font-serif italic text-lg">— nothing written yet —</p>
          ) : (
            entries.map((e, i) => (
              <p key={`${e.slice(0, 24)}-${i}`} className="font-serif text-lg leading-relaxed" data-testid={`journal-entry-${i}`}>
                <span className="italic text-black/50 mr-2">§{String(i + 1).padStart(2, "0")}</span>
                {e}
              </p>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
